import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const ChevronDownIcon: React.FC<IconProps> = props => (
  <Icon fill="currentColor" {...props}>
    <path d="M12 15.4L6 9.4L7.4 8L12 12.6L16.6 8L18 9.4L12 15.4Z" />
  </Icon>
)
